export const TEXTS = {
  EMPTY_TEXT: "",
  DEFAULT_ACTA_PROMPT_TEXT: "Or just buy this article",
  DEFAULT_ACTA_BUTTON_TEXT: "Read instantly for",
}